import { on } from 'delegated-events'

const SELECTORS = Selectors({
  element: 'element-internetacademydetails'
})

const $element = document.querySelectorAll(SELECTORS.asClass('element'))

const fn = {
  init: () => {
    on('click', `${SELECTORS.asClass('element')} .panel-item__title`, fn.toggle)
  },

  toggle: (e) => {
    const $content = $(e.target).siblings('.panel-item__content')

    $content.slideToggle()
    e.target.classList.toggle('is-active')
  }
}

export default {
  can: () => $element.length,
  run: fn.init
}
